import { useQuery } from "@apollo/client/react";
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import { constantsData } from "@/data";
import { getPermissionsListQuery } from "@/graph";
import { openAlert } from "@/redux/actions";
import { displayErrorHandler } from "@/utils";

const usePermissionsList = (id) => {
    const [initialPermissions, setInitialPermissions] = useState({
        id: null,
        permissions: {},
    });

    const [permissions, setPermissions] = useState({
        id: null,
        permissions: {},
    });

    const dispatch = useDispatch();

    const { t } = useTranslation();

    const { isAuthenticated } = useAuth0();

    const { data, error, loading, refetch } = useQuery(getPermissionsListQuery, {
        skip: !isAuthenticated,
        variables: {
            roleId: { id },
        },
    });

    useEffect(() => {
        if (data?.listPermissionsByRole) {
            setInitialPermissions(data.listPermissionsByRole.data);
            setPermissions(data.listPermissionsByRole.data);
        }
    }, [data]);

    useEffect(
        () => {
            if (error?.message === constantsData.failedToFetch && !loading) {
                displayErrorHandler(t("messages.networkFailure"), dispatch, openAlert);
            }
        },
        [error, data], // eslint-disable-line
    );

    return {
        initialPermissions,
        loading,
        permissions,
        refetch,
        setPermissions,
    };
};

export default usePermissionsList;
